<title mat-dialog-title>{{ 'common.addMedia' | t }}</title>
<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button
    mat-button
    color="success"
    type="submit"
    (click)="submitForm()"
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    [disabled]="!form.value.files"
  >
    {{ 'common.submit' | t }}
  </button>
</mat-dialog-actions>
